import * as _ from "lodash";
import http from "../constant/api";

export const profileAppearanceService = {
  readProfileAppearanceByProfileId: async (profileId) => {
    const result = await http.get(
      `/api/profile-appearance/read/profile-id/${profileId}`
    );

    return result;
  },
  addProfileAppearance: async (data, isFormData = false) => {
    const result = await http.post(`/api/profile-appearance/add`, data, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    });

    return result;
  },
  editProfileAppearance: async (id, data, isFormData = false) => {
    const result = await http.put(`/api/profile-appearance/${id}/edit`, data, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    });

    return result;
  },
  removeProfileAppearance: async (id) => {
    const result = await http.delete(`/api/profile-appearance/${id}/remove`);

    return result;
  },
};
